import { Inject, Injectable } from '@angular/core';
import { APP_SETTINGS } from '@config/app-settings';
import { AppSettings } from '@models/generic';

/**
 * Service that provides access to application settings
 * Settings are now provided via environment configuration (no more appsettings.json fetch)
 */
@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  constructor(@Inject(APP_SETTINGS) private readonly appSettingsField: AppSettings) {}

  get appSettings(): AppSettings {
    return this.appSettingsField;
  }
}
